var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "_pgn no-wrap",
      style: { width: _vm.width },
      attrs: { role: "tablist" }
    },
    [
      _c(
        "div",
        [
          _c(
            "ib-button",
            {
              staticClass: "fs7 link mirror-rtl",
              attrs: { disabled: _vm.page <= _vm.min },
              on: { click: _vm.start }
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 50 50"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M27.96 2.98c-.52.02-1.01.23-1.37.6L5.17 25 26.6 46.41a2 2 0 1 0 2.82-2.82L10.83 25 29.4 6.41a2 2 0 0 0-1.45-3.43zm13 0c-.52.02-1.01.23-1.37.6L18.17 25 39.6 46.41a2 2 0 1 0 2.82-2.82L23.83 25 42.4 6.41a2 2 0 0 0-1.45-3.43z"
                    }
                  })
                ]
              )
            ]
          ),
          _c(
            "ib-button",
            {
              staticClass: "fs7 link mirror-rtl",
              attrs: { disabled: _vm.page <= _vm.min },
              on: { click: _vm.prev }
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 24 24"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M14.78 2.28l-9 9-.69.72.7.72 9 9 1.43-1.44L7.94 12l8.28-8.28z"
                    }
                  })
                ]
              )
            ]
          )
        ],
        1
      ),
      _c(
        "div",
        { ref: "page", staticClass: "_pgl" },
        _vm._l(_vm.count, function(p) {
          return _c("a", {
            attrs: { role: "tab", "aria-selected": _vm.first + p === _vm.page },
            domProps: { textContent: _vm._s(_vm.first + p) },
            on: {
              click: function($event) {
                return _vm.goto(_vm.first + p)
              }
            }
          })
        }),
        0
      ),
      _c(
        "div",
        [
          _c(
            "ib-button",
            {
              staticClass: "fs7 link mirror-rtl",
              attrs: { disabled: _vm.page >= _vm.max },
              on: { click: _vm.next }
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 24 24"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M8.7 2.3L7.3 3.7l8.29 8.3-8.3 8.3 1.42 1.4 9.7-9.7z"
                    }
                  })
                ]
              )
            ]
          ),
          _c(
            "ib-button",
            {
              staticClass: "fs7 link mirror-rtl",
              attrs: { disabled: _vm.page >= _vm.max },
              on: { click: _vm.end }
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 50 50"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M8.98 2.98a2 2 0 0 0-1.4 3.43L26.19 25 7.57 43.59a2 2 0 1 0 2.83 2.82L31.83 25 10.4 3.59a2 2 0 0 0-1.43-.61zm13 0a2 2 0 0 0-1.4 3.43L39.19 25l-18.6 18.59a2 2 0 1 0 2.83 2.82L44.83 25 23.4 3.59a2 2 0 0 0-1.43-.61z"
                    }
                  })
                ]
              )
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }